import { useRect } from "@vant/use";
import { ref, onMounted, nextTick } from "vue";

var useHeight = function useHeight(element) {
  var height = ref();

  var setHeight = function setHeight() {
    height.value = useRect(element).height;
  };

  onMounted(function () {
    nextTick(setHeight);
    setTimeout(setHeight, 100);
  });
  return height;
};

export { useHeight };